import { IdeaSystemField } from 'src/app/core/models/idea.models';

export const SYSTEM_FIELD_NAMES: Readonly<{ [key in IdeaSystemField]?: string }> = {
  description: 'Description',
};

export const DEFAULT_SYSTEM_FIELDS: readonly IdeaSystemField[] = ['description'] as const;
